import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import FeedbackWidget from './components/FeedbackWidget';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Agents from './pages/Agents';
import Projects from './pages/Projects';
import Knowledge from './pages/Knowledge';
import Settings from './pages/Settings';
import SwarmDashboard from './pages/SwarmDashboard';
import TemplateLibrary from './pages/TemplateLibrary';
import ApiKeys from './pages/ApiKeys';
import ShareDashboard from './pages/ShareDashboard';
import Webhooks from './pages/Webhooks';
import Integrations from './pages/Integrations';
import Pricing from './pages/Pricing';
import Billing from './pages/Billing';
import Analytics from './pages/Analytics';
import Onboarding from './pages/Onboarding';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/onboarding" element={<Onboarding />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/swarm" element={<SwarmDashboard />} />
              <Route path="/templates" element={<TemplateLibrary />} />
              <Route path="/api-keys" element={<ApiKeys />} />
              <Route path="/share" element={<ShareDashboard />} />
              <Route path="/webhooks" element={<Webhooks />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/analytics" element={<Analytics />} />
            </Route>
          </Route>
        </Routes>
        <FeedbackWidget />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
